'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  border: none;\n'], ['\n  border: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UINotificationBadge = require('UIComponents/badge/UINotificationBadge');

var _UINotificationBadge2 = _interopRequireDefault(_UINotificationBadge);

var _FadeTransition = require('./FadeTransition');

var _FadeTransition2 = _interopRequireDefault(_FadeTransition);

var _color = require('../visitor-widget/util/color');

var _Images = require('../visitor-widget/constants/Images');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LauncherButton = _styledComponents2.default.button.withConfig({
  displayName: 'Launcher__LauncherButton'
})(_templateObject);

exports.default = _react2.default.createClass({
  displayName: 'Launcher',

  propTypes: {
    badgeNumber: _react.PropTypes.number,
    className: _react.PropTypes.string,
    coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
    onClose: _react.PropTypes.func.isRequired,
    onOpen: _react.PropTypes.func.isRequired,
    open: _react.PropTypes.bool.isRequired,
    showBadge: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onOpen: _emptyFunction2.default,
      onClose: _emptyFunction2.default,
      open: false
    };
  },
  handleLaunch: function handleLaunch() {
    var _props = this.props,
        onOpen = _props.onOpen,
        onClose = _props.onClose,
        open = _props.open;


    if (open) {
      onClose();
    } else {
      onOpen();
    }
  },
  getIcon: function getIcon(open, isDark) {
    if (open) {
      if (isDark) {
        return _Images.launcherClosedDark;
      }
      return _Images.launcherClosed;
    }

    if (isDark) {
      return _Images.launcherOpenDark;
    }
    return _Images.launcherOpen;
  },
  renderIcon: function renderIcon() {
    var _props2 = this.props,
        open = _props2.open,
        useDefaultColor = _props2.coloring.useDefaultColor;


    var iconClassName = (0, _classNames2.default)('widget-launcher-icon', {
      close: open,
      open: !open
    });

    var icon = this.getIcon(open, useDefaultColor);
    var key = open ? 'launcher-close-icon' : 'launcher-open-icon';
    var label = this.props.open ? 'conversations-visitor-experience-components.visitorExperienceAriaLabels.close' : 'conversations-visitor-experience-components.visitorExperienceAriaLabels.open';

    return _react2.default.createElement(_UIImage2.default, {
      className: iconClassName,
      src: icon,
      key: key,
      alt: _I18n2.default.text(label)
    });
  },
  renderLauncher: function renderLauncher() {
    var _props3 = this.props,
        showBadge = _props3.showBadge,
        badgeNumber = _props3.badgeNumber;


    if (showBadge) {
      return _react2.default.createElement(
        _UINotificationBadge2.default,
        {
          badgeLabel: badgeNumber,
          className: 'notification-badge',
          placement: 'inset'
        },
        this.renderIcon()
      );
    }
    return this.renderIcon();
  },
  render: function render() {
    var _props4 = this.props,
        accentColor = _props4.coloring.accentColor,
        className = _props4.className;

    var label = this.props.open ? 'conversations-visitor-experience-components.visitorExperienceAriaLabels.close' : 'conversations-visitor-experience-components.visitorExperienceAriaLabels.open';

    return _react2.default.createElement(
      LauncherButton,
      _extends({}, (0, _color.getBrandClassNameAndStyle)(accentColor, (0, _classNames2.default)('widget-launcher reagan--widget-loaded', className)), {
        onClick: this.handleLaunch,
        tabIndex: '0',
        role: 'button',
        type: 'button',
        'aria-label': _I18n2.default.text(label),
        'aria-pressed': !this.props.open
      }),
      _react2.default.createElement(
        _FadeTransition2.default,
        null,
        this.renderLauncher()
      )
    );
  }
});
module.exports = exports['default'];